import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalOptionsConfig, ModalService } from '../../../../nz-modal-service/modal.service';
import { EditTransactionLimitModalComponent } from '../edit-transaction-limit-modal/edit-transaction-limit-modal.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { AppConfig } from '../../../../../../shared/config/app-config';
import { Router } from '@angular/router';

@Component({
  selector: 'app-transfer-info-card',
  templateUrl: './transfer-info-card.component.html',
  styleUrls: ['./transfer-info-card.component.scss']
})
export class TransferInfoCardComponent implements OnInit {

  @Input() type = 'limit_exceed';
  @Input() dailyWebTransactionLimit: number;
  @Input() dailyAmountTransfered: number;
  @Input() remainingAmount: number;
  @Input() isMobile: boolean;
  @Input() maxTransferLimit: number;
  @Input() transactionType: "Transfer" | "Airtime" | "Bill Payment";
  @Output() updateDailyLimit = new EventEmitter();
	runningModal: NzModalRef;
	showEditTransferLimitModal: boolean;

  constructor(
		public modalService: ModalService,
		private router: Router,
		public config: AppConfig
  ) { }

  ngOnInit(): void {
		this.showEditTransferLimitModal = this.config.SHOW_TRANSFER_LIMIT_MODAL;
  }

  createEditTansferLimitModal() {
		if(this.config.USE_NEW_DAILY_LIMIT_FLOW){
			return this.routeToTrasferLimitPage()
		}

		const modalData = {
			isMobile: this.isMobile,
			maxDailyLimit: this.maxTransferLimit,
			transactionType: this.transactionType
		};
		const config = new ModalOptionsConfig();
		config.className = 'moniepoint-dialog';
		config.nzMaskClosable = true;
		config.nzComponentParams.data = modalData;
		config.nzComponentParams.callback = (result) => {
			this.updateDailyLimit.emit(result);
		};
		this.runningModal = this.modalService.createModal(EditTransactionLimitModalComponent, config);
	}

	routeToTrasferLimitPage(){
		const TRANSACTION_LIMIT_ROUTE = '/main-app/business-user/settings/transaction/limit';
		this.router.navigateByUrl(TRANSACTION_LIMIT_ROUTE);
	}
}
